import React from "react";

import {
  isKintoneSubtableFormField,
  kintoneFieldReadableTypeName,
  KintoneFormFields,
} from "@graffer-inc/cloud-gov-core";
import { MessageDialog, TextButton } from "@graffer-inc/console-design-kit";

type KintoneFieldsViewerProps = {
  kintoneFormFields: KintoneFormFields;
};

export const KintoneFieldsViewer: React.FC<KintoneFieldsViewerProps> = ({
  kintoneFormFields,
}) => {
  const [showDialog, setShowDialog] = React.useState(false);
  return (
    <>
      <TextButton
        icon="ListviewIcon"
        text="kintone フィールドの一覧を表示する"
        onClick={() => setShowDialog(true)}
      />
      {showDialog && (
        <MessageDialog
          title="kintone フィールドの一覧"
          contents={
            <div className="field" style={{ width: "480px" }}>
              <textarea
                className="textarea"
                value={kintoneFormFieldsToListText(kintoneFormFields)}
                rows={20}
                readOnly
              />
            </div>
          }
          onCancel={() => setShowDialog(false)}
          cancelText="閉じる"
        />
      )}
    </>
  );
};

const kintoneFormFieldsToListText = (
  kintoneFormFields: KintoneFormFields,
): string => {
  return Object.values(kintoneFormFields)
    .map((field) => {
      if (isKintoneSubtableFormField(field)) {
        const childrenText = Object.values(field.fields)
          .map((child) => {
            const optionsText =
              "options" in child
                ? `      - 選択肢: ${Object.values(child.options)
                    .map((option) => option.label)
                    .join(", ")}\n`
                : "";
            return `    - ${child.label}\n      - コード: ${
              child.code
            }\n      - タイプ: ${kintoneFieldReadableTypeName(
              child.type,
            )}\n${optionsText}`;
          })
          .join("");
        return `- ${field.label}\n  - コード: ${
          field.code
        }\n  - タイプ: ${kintoneFieldReadableTypeName(
          field.type,
        )}\n  - 子フィールド:\n${childrenText}`;
      }

      const optionsText =
        "options" in field
          ? `  - 選択肢: ${Object.values(field.options)
              .map((option) => option.label)
              .join(", ")}\n`
          : "";
      return `- ${field.label}\n  - コード: ${
        field.code
      }\n  - タイプ: ${kintoneFieldReadableTypeName(
        field.type,
      )}\n${optionsText}`;
    })
    .join("---\n");
};
